import type { InjectionKey, Ref } from 'vue'

export const PanelModeKey: InjectionKey<Ref<'panel' | 'modal'>> = Symbol('PanelMode')
